<script>
import { Line } from 'vue-chartjs'
// import { Line, mixins } from 'vue-chartjs'
// const { reactiveProp } = mixins

export default {
  extends: Line,
  // mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    'chartData.labels': function () {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
